import { useTranslation } from "react-i18next";

import { cn } from "@/lib/utils";

/**
 * Brand loading indicator: the Clinova mark pulsing softly, with a small
 * "loading…" caption. Rendered by `Loading` and every Suspense fallback.
 */
export function LoadingAnimationSvg({ className }: { className?: string }) {
  const { t } = useTranslation();

  return (
    <div
      data-slot="loading-animation-svg"
      className={cn("grid place-items-center gap-3", className)}
      role="status"
      aria-live="polite"
    >
      <svg
        viewBox="0 0 64 64"
        className="size-14 animate-brand-pulse"
        aria-hidden="true"
      >
        <rect width="64" height="64" rx="14" fill="#2563eb" />
        <path
          d="M42.5 22.5a14 14 0 1 0 0 19"
          fill="none"
          stroke="#ffffff"
          strokeWidth="6"
          strokeLinecap="round"
        />
        <path
          d="M32 26v12M26 32h12"
          fill="none"
          stroke="#ffffff"
          strokeWidth="4.5"
          strokeLinecap="round"
        />
      </svg>
      <p className="pl-3 text-center text-xs font-medium tracking-widest text-gray-500 uppercase">
        {t("loading_animation_text")}
        <span className="animate-blink opacity-0">.</span>
        <span className="animate-[blink_1.5s_0.2s_infinite] opacity-0">.</span>
        <span className="animate-[blink_1.5s_0.4s_infinite] opacity-0">.</span>
      </p>
    </div>
  );
}
